import React from "react";
interface VideoSectionProps {
  title: string;
  videoEmbedId: string;
}
const VideoSection: React.FC<VideoSectionProps> = ({
  title,
  videoEmbedId
}) => {
  const isYouTubeVideo = videoEmbedId.includes('youtube.com') || videoEmbedId.length === 11;
  const videoSrc = isYouTubeVideo ? `https://www.youtube.com/embed/${videoEmbedId}` : videoEmbedId;
  return <section className="py-0 bg-black/0">
      <div className="container mx-auto px-4 md:px-8 my-[68px]">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-drcash-maastricht-blue mt-20">
            {title}
          </h2>
        </div>
        
        <div className="max-w-4xl mx-auto relative aspect-video rounded-xl overflow-hidden shadow-xl">
          {isYouTubeVideo ? <iframe className="absolute inset-0 w-full h-full" src={videoSrc} title="Dr.Cash Demonstration Video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen loading="lazy"></iframe> : <video className="absolute inset-0 w-full h-full object-cover" src={videoSrc} controls preload="metadata">
              Seu navegador não suporta a reprodução de vídeo.
            </video>}
        </div>
      </div>
    </section>;
};
export default VideoSection;